export default "__VITE_PUBLIC_ASSET__f13b140d__"